/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Filters_Name_PlaceholderInputs */

const es_settings_files_filters_name_placeholder = /** @type {(inputs: Settings_Files_Filters_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar por nombre…`)
};

const en_settings_files_filters_name_placeholder = /** @type {(inputs: Settings_Files_Filters_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by name…`)
};

/**
* | output |
* | --- |
* | "Filter by name…" |
*
* @param {Settings_Files_Filters_Name_PlaceholderInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_filters_name_placeholder = /** @type {((inputs?: Settings_Files_Filters_Name_PlaceholderInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Filters_Name_PlaceholderInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_filters_name_placeholder(inputs)
	return en_settings_files_filters_name_placeholder(inputs)
});
export { settings_files_filters_name_placeholder as "settings.files.filters.name_placeholder" }